var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scanShow)?_c('div',{staticClass:"page bgc-f4f4f4"},[_c('div',{staticClass:"video-show"},[_vm._v(_vm._s(_vm.videoLength))]),_c('video',{ref:"video",staticClass:"video vjs-fluid",attrs:{"id":"video","autoplay":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }